import { MapDataService } from '@ui/shared/domain-map';
import { map, type Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { SpecialUsageMapService, VenueOrderingEnum } from '@ui/shared/util-api';
import { toRequestQuery } from '@ui/shared/util-filter';
import { ProjectListItemModel } from '../../definitions/project-list-item.model';
import type { ProjectListFilter } from '../../types/project-list-filters';

@Injectable({ providedIn: 'root' })
export class ProjectListVenueMapDataService extends MapDataService<ProjectListItemModel, ProjectListFilter> {
    protected _api = inject(SpecialUsageMapService);

    public getData$(filter: ProjectListFilter): Observable<Array<ProjectListItemModel>> {
        return this._api
            .getAllVenues({
                titleContains: typeof filter.search === 'string' ? filter.search : null,
                districtIds: toRequestQuery(filter.district),
                specialUsageKindIds: toRequestQuery(filter.specialUsageKind),
                order: [VenueOrderingEnum.Title],
            })
            .pipe(map(response => response.data.map(dto => new ProjectListItemModel(dto))));
    }
}
